var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFarmers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 69,
    viewBox: "0 0 52 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.55176 24.3901C17.313 16.1768 32.7647 16.9699 49.7898 21.2908M9.67901 18.1931C17.0526 -5.64636 35.0124 -0.758725 41.4007 18.3621M10.3017 26.4867C6.96838 26.6034 10.3017 29.8686 12.385 31.4867C10.3017 51.2784 40.7184 50.8618 38.6351 30.0284C40.024 28.7784 41.9684 26.1117 38.6351 25.445M21.5517 29.1953C21.5517 28.5033 21.5517 27.8062 21.5517 27.112M29.2599 29.1953C28.8147 28.5045 28.8437 27.812 28.8437 27.112M28.569 36.9035C26.8556 38.1831 24.0594 38.1831 22.8015 37.4833M4.18519 64.5423C3.44377 42.9326 36.4994 43.8778 41.8108 51.9377C44.4873 55.9989 45.0167 62.1535 45.8567 67.1121M15.446 57.065C21.4524 56.3014 28.0264 57.5573 33.7973 57.1437M35.1324 50.0755C33.9097 55.3522 35.0276 60.5103 35.0276 65.8014M14.6966 52.4346C15.2053 56.8292 14.8278 61.4567 15.4091 65.8017",
    stroke: "#2A310C",
    strokeWidth: 2.79724,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmers);
export default __webpack_public_path__ + "static/media/farmers.3966eb70b1196e7db93bfb7c2d099d03.svg";
export { ForwardRef as ReactComponent };